const SECONDS_PER_HOUR = 3600;

/**
 * Hours from a duration stored in seconds; null stays null.
 * @param {number|null|undefined} seconds
 * @returns {number|null}
 */
export const secondsToHours = (seconds) => {
  if (seconds === null || seconds === undefined) {
    return null;
  }

  return seconds / SECONDS_PER_HOUR;
};

/**
 * Whole seconds from a duration entered in hours; null stays null.
 * @param {number|null|undefined} hours
 * @returns {number|null}
 */
export const hoursToSeconds = (hours) => {
  if (hours === null || hours === undefined) {
    return null;
  }

  return Math.round(Number(hours) * SECONDS_PER_HOUR);
};
